// Using Vue for the sqft calcualtor/repeater
const totalWidth = '0'
const total = new Vue({
  el: '#SQFTcalculator',

  data: {
    items: [],
    openItems: [],
    toggle: ['two'],
  },

  computed: {
    totalSqft() {
      const sum = this.items.reduce((total, item) => {
        return total + (item.widthinches / 12 + Number(item.widthfeet)) * (Number(item.heightfeet) + item.heightinches / 12);
      }, 0);
      return sum.toFixed(2);
    },
    removeSqft() {
      const sum = this.openItems.reduce((total, item) => {
        return total + (item.widthinches / 12 + Number(item.widthfeet)) * (Number(item.heightfeet) + item.heightinches / 12);
      }, 0);
      return sum.toFixed(2);
    },
    totalInches(){
      return this.items.reduce((total, item) => {
        return total + item.widthinches / 12;
      }, 0);
    },
    totalFeet() {
      return this.items.reduce((total, item) => {
        return total + Number(item.widthfeet);
      }, 0);
    },
    totalWidth(){
      return this.totalInches + this.totalFeet;
    },
    totalTotal(){
      return (this.totalSqft - this.removeSqft).toFixed(2);
    },
  },

  created() {
    this.addItem();
    this.addOpenItem();
  },

  methods: {

    addItem() {
      this.items.push({
        widthinches: 0,
        widthfeet: 0,
        heightinches: 0,
        heightfeet: 0,
      });
    },
    addOpenItem() {
      this.openItems.push({
        widthinches: 0,
        widthfeet: 0,
        heightinches: 0,
        heightfeet: 0,
      });
    },
    deleteItem(i) {
      this.$delete(this.items, i);
    },
    deleteOpenItem(i) {
      this.$delete(this.openItems, i);
    },
    toggleItem: function (key) {
      var i = this.toggle.indexOf(key)
      if (i < 0) {
        this.toggle.push(key)
      } else {
        this.toggle.splice(i, 1)
      }
    }
  },

});

  